import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES, ROUTE_METADATA } from '@/constants/routes';

export const useDocumentTitle = () => {
    const location = useLocation();

    useEffect(() => {
        // Lấy title từ ROUTE_METADATA dựa trên pathname hiện tại
        const currentRoute = Object.entries(ROUTES).find(([_, path]) => path === location.pathname);

        if (currentRoute) {
            const [, routePath] = currentRoute;
            const metadata = ROUTE_METADATA[routePath as keyof typeof ROUTE_METADATA];

            if (metadata && metadata.title) {
                document.title = `${metadata.title} - Hệ thống quản trị`;
            } else {
                document.title = 'Hệ thống quản trị';
            }
        } else {
            // Fallback cho các route không được định nghĩa
            document.title = 'Hệ thống quản trị';
        }
    }, [location.pathname]);
};
